import { ROUTES } from '../../utils/constants';

const DESIGNER_ROLES = new Set(['admin', 'superadmin', 'tenant_admin']);

export function canConfigureTenantHome({ role, dealerActive = false } = {}) {
  if (dealerActive) return true;
  return DESIGNER_ROLES.has(String(role || ''));
}

export function homeGuidanceSteps({ role, dealerActive = false, algoDeviceSupport = false } = {}) {
  if (!canConfigureTenantHome({ role, dealerActive })) return [];
  const steps = [
    {
      id: 'home',
      hideStatus: true,
      parts: [
        { text: 'Customize home screen here or in the ' },
        { text: 'Home designer', to: ROUTES.ADMIN_WORKSPACES },
      ],
    },
    { id: 'action', hideStatus: true, label: 'Create an Action', to: ROUTES.ADMIN_ACTIONS },
    { id: 'flow', hideStatus: true, label: 'Create Flows', to: ROUTES.ADMIN_FLOWS },
    {
      id: 'shortcuts',
      hideStatus: true,
      label: 'Add a button to the home screen and assign Flows or Actions to the button',
      to: ROUTES.ADMIN_WORKSPACES,
    },
  ];
  if (algoDeviceSupport === true) {
    steps.splice(1, 0, { id: 'agent', hideStatus: true, label: 'Connect an agent', to: ROUTES.AGENT_MANAGEMENT });
  }
  return steps;
}

export function homeGuidanceProgress({
  homeConfigured = false,
  flowState = 'loading',
  flowCount = 0,
  shortcutState = 'loading',
  shortcutCount = 0,
} = {}) {
  const measured = (state, count) => {
    if (state === 'loading') return 'loading';
    if (state === 'error') return 'error';
    if (state === 'unavailable') return 'unavailable';
    return count > 0 ? 'complete' : 'not-configured';
  };
  return {
    home: homeConfigured ? 'complete' : 'not-configured',
    agent: 'unverified',
    flow: measured(flowState, flowCount),
    shortcuts: measured(shortcutState, shortcutCount),
  };
}

export function homeGuidanceFinished(progress) {
  if (!progress) return false;
  return progress.home === 'complete'
    && progress.flow === 'complete'
    && progress.shortcuts === 'complete';
}

export function homeSetupCardVisible({
  guide = false,
  preparing = false,
  notice = '',
} = {}) {
  return Boolean(guide || preparing || notice);
}

export function homeSetupStepsVisible({ guide = false, notice = '' } = {}) {
  return Boolean(guide) && !String(notice || '').trim();
}

export function guidanceDismissalKey(uid, tenantId) {
  if (!uid || !tenantId) return null;
  return `home_guidance_dismissed_${uid}_${tenantId}`;
}
